import { render, staticRenderFns } from "./generateBill.vue?vue&type=template&id=0bc78374&"
import script from "./generateBill.js?vue&type=script&lang=js&"
export * from "./generateBill.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc78374')) {
      api.createRecord('0bc78374', component.options)
    } else {
      api.reload('0bc78374', component.options)
    }
    module.hot.accept("./generateBill.vue?vue&type=template&id=0bc78374&", function () {
      api.rerender('0bc78374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/generateBill/generateBill.vue"
export default component.exports